<script lang="ts">
  import { Tooltip } from 'bootstrap';
  import { type Snippet } from 'svelte';

  interface Props {
    children: Snippet;
    title: string;
    disabled?: boolean;
  }

  let { children, title, disabled }: Props = $props();
  let element: HTMLDivElement;
  let bsTooltip: Tooltip | null;

  $effect(() => {
    if (!disabled) {
      bsTooltip = new Tooltip(element);
    }

    return () => {
      try {
        bsTooltip?.dispose();
      } catch {
        // do nothing — sometimes this fails to dispose because the elements are already removed from dom
      }
    };
  });
</script>

<div style="display: inline-block;" bind:this={element} data-bs-toggle="tooltip" data-bs-title={title}>
  {@render children()}
</div>
